<ng-container [formGroup]="editorFormGroup()">
  <lib-input-container
    [label]="label()"
    [attr.for]="id()"
    [maxLength]="maxLength()"
    [currentLength]="length()"
    [errorText]="errorText() || translationMissingError()"
    [required]="required()"
    [questionMarkText]="questionMarkText()"
  >
    <editor
      [attr.id]="id()"
      [formControl]="editorFormControl()"
      [init]="tinyMceConfig"
      licenseKey="gpl"
      (onKeyDown)="onKeydown($event.event)"
      (onBlur)="onBlur()"
      [class.error]="!!errorText() || !!translationMissingError()"
    />
  </lib-input-container>
</ng-container>
